export default __webpack_public_path__ + "static/media/Chestguard of the Chaos Agent.23e38f76.jpg";